import { render, staticRenderFns } from "./CompImage.vue?vue&type=template&id=7570d6b2&scoped=true&"
import script from "./CompImage.vue?vue&type=script&lang=ts&"
export * from "./CompImage.vue?vue&type=script&lang=ts&"
import style0 from "./CompImage.vue?vue&type=style&index=0&id=7570d6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570d6b2",
  null
  
)

export default component.exports